import {
    DashboardIcon,
    ProjectIcon,
    ChatIcon,
    TourIcon,
    ShortCutIcon,
    DetailIcon,
    UserIcon,
    PurchaseOrderIcon,
    CompleteCheckIcon,
    ResourceUtilization,
    ProductIcon,
    CategoryIcon,
    SubCategoryIcon,
    LinkIcon,
    QRCodeIcon
} from 'assets';
import { routeConstant } from 'shared/routes/RouteConstant';

const mainNavigationAdmin = [
    {
        Icon: DashboardIcon,
        text: 'Dashboard',
        path: routeConstant.admin.dashboard.path
    },
    {
        Icon: UserIcon,
        text: 'Users',
        path: routeConstant.admin.manageUser.path
    },
    {
        Icon: ProductIcon,
        text: 'Product',
        path: routeConstant.admin.manageProduct.path,
        img: true
    },
    {
        Icon: PurchaseOrderIcon,
        text: 'Rough Listing',
        path: routeConstant.admin.roughListing.list.path
    },
    {
        Icon: PurchaseOrderIcon,
        text: 'Purchase Order',
        path: routeConstant.admin.po.list.path
    },
    {
        Icon: CompleteCheckIcon,
        text: 'Inventory',
        path: routeConstant.admin.inventory.list.path
    },
    {
        Icon: ResourceUtilization,
        text: 'Manage Tasks',
        path: routeConstant.admin.manageTask.path
    },
    {
        Icon: PurchaseOrderIcon,
        text: 'Sale Order',
        path: routeConstant.admin.so.list.path
    },
    {
        Icon: PurchaseOrderIcon,
        text: 'Internal Transfer',
        path: routeConstant.admin.internalTransfer.list.path
    },
    {
        Icon: PurchaseOrderIcon,
        text: 'Return Order',
        path: routeConstant.admin.returnOrder.list.path
    },
    {
        Icon: LinkIcon,
        text: 'Match Products',
        path: routeConstant.admin.matchProducts.list.path
    },
    {
        Icon: QRCodeIcon,
        text: 'QR Codes',
        path: routeConstant.admin.qrCodes.list.path
    }
];
const mainNavigationUser = [
    {
        Icon: DashboardIcon,
        text: 'All Task',
        path: routeConstant.admin.dashboard.path
    }
];

const helpDropDownOptions = [
    {
        Icon: DetailIcon,
        title: 'View quick start guide',
        desc: 'Get up to spend in minutes.'
    },
    {
        Icon: TourIcon,
        title: 'Product tour',
        desc: 'Highlight key menu items.'
    },
    {
        Icon: ChatIcon,
        title: 'Chat',
        desc: 'Message support directly.'
    },
    {
        Icon: ShortCutIcon,
        title: 'Shortcuts',
        desc: 'Faster ways to schedule.'
    }
];
const helpDropDownEnum = {
    guide: 'View quick start guide',
    tour: 'Product tour',
    chat: 'Chat',
    shortcuts: 'Shortcuts'
};
const notficationList = [
    {
        text1: 'New',
        active: 'Milestone',
        text2: ' feature is in the app.'
    },
    {
        text1: 'New',
        active: 'Milestone',
        text2: ' feature is in the app.'
    },
    {
        text1: 'New',
        active: 'Milestone',
        text2: ' feature is in the app.'
    },
    {
        text1: 'New',
        active: 'Milestone',
        text2: ' feature is in the app.'
    }
];

const checkPathConstaint = {
    dashboard: '/dashboard',
    project: '/project',
    user: '/user',
    resource: '/resource',
    client: '/client',
    revenue: '/revenue',
    team: '/team',
    setting: '/setting',
    internal_transfer: '/internal_transfer',
    return: '/return',
    rough_listing: '/rough-listing',
    po: '/po',
    so: '/so',
    inventory: '/inventory',
    product: '/product',
    task: '/task',
    qr_codes: '/qr-codes',
};
export { mainNavigationUser, mainNavigationAdmin, checkPathConstaint, notficationList, helpDropDownEnum, helpDropDownOptions };
